import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'
import { Item } from 'gnos-context-menu'

import { canGenerateDistraints } from '@global/helpers'

import hocFavourites from '../../../EntityStack/components/StackContent/components/FavouritesContent/hocFavourites'
import acl from '../../../../../../services/acl/index'

import { LOCALE_PREFIX, ENTITY_CONTEXT_MENU_ITEM } from './constants'

import hocConnect from './hocConnect'

const idFavoritesSelector = (props) => _.get(props, 'rowData.id', null)

@acl
@hocConnect
@hocFavourites(idFavoritesSelector)
export default class EntityContextMenu extends Component {
    static propTypes = {
        addToFavourites: PropTypes.func.isRequired,
        hasRights: PropTypes.func.isRequired,
        items: PropTypes.array,
        openLinkagesById: PropTypes.func.isRequired,
        openReportById: PropTypes.func.isRequired,
        removeFromFavourites: PropTypes.func.isRequired,
        rowData: PropTypes.object.isRequired,
        shouldAddToFavourites: PropTypes.bool.isRequired,
        setupDistraintsById: PropTypes.func.isRequired,
    }

    static defaultProps = {
        items: [],
    }

    onContextMenuAddReportClick = () => {
        const { openReportById, rowData } = this.props
        const id = _.get(rowData, 'id', null)

        if (id) openReportById(_.toString(id))
    }

    onContextMenuAddLinkagesClick = () => {
        const { openLinkagesById, rowData } = this.props
        const id = _.get(rowData, 'id', null)

        if (id) openLinkagesById(id)
    }

    onAddToFavourites = () => {
        const { addToFavourites, rowData } = this.props
        const id = _.get(rowData, 'id', null)

        if (id) addToFavourites(id)
    }

    onRemoveFromFavourites = () => {
        const { removeFromFavourites, rowData } = this.props
        const id = _.get(rowData, 'id', null)

        if (id) removeFromFavourites(id)
    }

    onContextMenuHandleDistraintsClick = () => {
        const { setupDistraintsById, rowData } = this.props
        const id = _.get(rowData, 'id', null)

        if (id) setupDistraintsById(_.toString(id))
    }

    render() {
        const { items, hasRights, shouldAddToFavourites, rowData } = this.props
        const { ADD_FAVOURITE, REMOVE_FAVOURITE, REPORT, LINKAGES, DISTRAINTS } = ENTITY_CONTEXT_MENU_ITEM

        const entity = rowData?.row?.original

        return _.map(items, (item) => {
            switch (item) {
                case REPORT: {
                    return (
                        hasRights(REPORT) && (
                            <Item
                                key={item}
                                type={item}
                                text={
                                    <span>
                                        <FormattedMessage id={`${LOCALE_PREFIX}.contextMenu.${item}`} />
                                    </span>
                                }
                                onItemClick={this.onContextMenuAddReportClick}
                            />
                        )
                    )
                }
                case LINKAGES: {
                    return (
                        hasRights(LINKAGES) && (
                            <Item
                                key={item}
                                type={item}
                                text={<FormattedMessage id={`${LOCALE_PREFIX}.contextMenu.${item}`} />}
                                onItemClick={this.onContextMenuAddLinkagesClick}
                            />
                        )
                    )
                }
                case REMOVE_FAVOURITE: {
                    return (
                        !shouldAddToFavourites && (
                            <Item
                                key={item}
                                type={'delete'}
                                text={<FormattedMessage id={`${LOCALE_PREFIX}.contextMenu.${item}`} />}
                                onItemClick={this.onRemoveFromFavourites}
                            />
                        )
                    )
                }
                case ADD_FAVOURITE: {
                    return (
                        shouldAddToFavourites && (
                            <Item
                                key={item}
                                type={'favorite'}
                                text={<FormattedMessage id={`${LOCALE_PREFIX}.contextMenu.${item}`} />}
                                onItemClick={this.onAddToFavourites}
                            />
                        )
                    )
                }
                case DISTRAINTS: {
                    return (
                        hasRights(DISTRAINTS) &&
                        canGenerateDistraints(entity?.country) && (
                            <Item
                                key={'distraints'}
                                type={'distraints'}
                                text={<FormattedMessage id={`${LOCALE_PREFIX}.contextMenu.${item}`} />}
                                onItemClick={this.onContextMenuHandleDistraintsClick}
                            />
                        )
                    )
                }
                default:
                    return null
            }
        })
    }
}
